import { defineStore } from 'pinia'
import api from '@/https/api'

/** 本页签已向后端核实过会话；与 userInfo persist 不能同时开，否则可被一起注入。 */
const TAB_AUTH_VERIFIED_KEY = 'shizi-tab-auth-verified'

const readTabVerified = () =>
  sessionStorage.getItem(TAB_AUTH_VERIFIED_KEY) === '1'

const writeTabVerified = (verified: boolean) => {
  if (verified) {
    sessionStorage.setItem(TAB_AUTH_VERIFIED_KEY, '1')
    return
  }
  sessionStorage.removeItem(TAB_AUTH_VERIFIED_KEY)
}

/** 关掉 persist 后清掉旧插件写入的 user-info，避免注入残留被误读。 */
sessionStorage.removeItem('user-info')
localStorage.removeItem('user-info')

const useUserStoreUserInfo = defineStore({
  id: 'user-info',
  state: () => ({
    userInfo: <any>{},
    naripm_username: null,
    aiSessionId: null
  }),
  actions: {
    isTabVerified() {
      return readTabVerified()
    },
    async getUserInfo(config = {}) {
      try {
        const { data } = await api.login.getUserInfo(config)
        if (data?.userId) {
          Object.assign(this.userInfo, data)
          writeTabVerified(true)
        } else {
          this.clearInfo()
        }
      } catch {
        this.clearInfo()
      }
    },
    clearInfo() {
      this.userInfo = {}
      writeTabVerified(false)
    }
  }
})

export default useUserStoreUserInfo
